import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import router from './router'
import { setupVant } from './utils/vant'
import { useAdsStore } from './stores/ads'

// 引入 pinia
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

// 创建应用
const app = createApp(App)

// 创建 pinia 实例
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

// 注册插件
setupVant(app)
app.use(pinia)
app.use(router)

// 初始化检查更新 广告 和 分类
const adsStore = useAdsStore()
adsStore.checkForUpdates()

// 挂载应用
app.mount('#app')

